"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarketAndAuthorityInfo = exports.findPsyOpenOrdersAddress = exports.findFeeParameters = exports.findOptionParameters = exports.findOtcTermsAddress = exports.findOpenOrdersAddress = exports.findUserAccountAddress = exports.findPricePerShareAddress = exports.findDerivativeVaultAddress = exports.findWriterVaultAddress = exports.findOptionVaultAddress = exports.findQuoteVaultAddress = exports.findUnderlyingVaultAddress = exports.findDerivativeMint = exports.findVaultAuthority = exports.findStateAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const web3_js_1 = require("@solana/web3.js");
const util_1 = require("util");
const utf8 = anchor_1.utils.bytes.utf8;
const MINT = utf8.encode("mint");
const STATE = utf8.encode("state");
const USER_ACCOUNT = utf8.encode("user-account");
const VAULT = utf8.encode("vault");
const PRICE_PER_SHARE = utf8.encode("price-per-share");
const OPEN_ORDERS = utf8.encode("open-orders");
const OTC = utf8.encode("otc");
const AUTHORITY = utf8.encode("authority");
const UNDERLYING = utf8.encode("underlying");
const QUOTE = utf8.encode("quote");
const OPTION = utf8.encode("option");
const WRITER = utf8.encode("writer");
const DERIVATIVE = utf8.encode("derivative");
const OPTION_PARAMETERS = utf8.encode("option-parameters");
const FEE_PARAMETERS = utf8.encode("fee-parameters");
const EARLY_ACCESS = utf8.encode("early-access");
const findStateAddress = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        STATE,
        ...identityContext.getIdentifiers()
    ], programId);
};
exports.findStateAddress = findStateAddress;
const findVaultAuthority = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        AUTHORITY
    ], programId);
};
exports.findVaultAuthority = findVaultAuthority;
const findDerivativeMint = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        MINT,
        ...identityContext.getIdentifiers(),
        DERIVATIVE
    ], programId);
};
exports.findDerivativeMint = findDerivativeMint;
const findUnderlyingVaultAddress = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        UNDERLYING
    ], programId);
};
exports.findUnderlyingVaultAddress = findUnderlyingVaultAddress;
const findQuoteVaultAddress = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        QUOTE
    ], programId);
};
exports.findQuoteVaultAddress = findQuoteVaultAddress;
const findOptionVaultAddress = async (identityContext, optionMint, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        OPTION,
        optionMint.toBuffer()
    ], programId);
};
exports.findOptionVaultAddress = findOptionVaultAddress;
const findWriterVaultAddress = async (identityContext, writerMint, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        WRITER,
        writerMint.toBuffer()
    ], programId);
};
exports.findWriterVaultAddress = findWriterVaultAddress;
const findDerivativeVaultAddress = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        VAULT,
        ...identityContext.getIdentifiers(),
        DERIVATIVE
    ], programId);
};
exports.findDerivativeVaultAddress = findDerivativeVaultAddress;
const findPricePerShareAddress = async (identityContext, pageIndex, programId) => {
    const pageIndexBuffer = Buffer.alloc(16);
    pageIndexBuffer.writeInt32LE(pageIndex, 0);
    return await web3_js_1.PublicKey.findProgramAddress([
        PRICE_PER_SHARE,
        ...identityContext.getIdentifiers(),
        pageIndexBuffer
    ], programId);
};
exports.findPricePerShareAddress = findPricePerShareAddress;
const findUserAccountAddress = async (userAuthority, stateKey, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        USER_ACCOUNT,
        userAuthority.toBuffer(),
        stateKey.toBuffer()
    ], programId);
};
exports.findUserAccountAddress = findUserAccountAddress;
const findOpenOrdersAddress = async (market, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        OPEN_ORDERS,
        market.toBuffer()
    ], programId);
};
exports.findOpenOrdersAddress = findOpenOrdersAddress;
const findOtcTermsAddress = async (stateKey, sellMint, buyMint, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        OTC,
        stateKey.toBuffer(),
        sellMint.toBuffer(),
        buyMint.toBuffer(),
    ], programId);
};
exports.findOtcTermsAddress = findOtcTermsAddress;
const findOptionParameters = async (identityContext, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        OPTION_PARAMETERS,
        ...identityContext.getIdentifiers(),
    ], programId);
};
exports.findOptionParameters = findOptionParameters;
const findFeeParameters = async (stateKey, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        FEE_PARAMETERS,
        stateKey.toBuffer()
    ], programId);
};
exports.findFeeParameters = findFeeParameters;
const openOrdersSeed = Buffer.from([
    111, 112, 101, 110, 45, 111, 114, 100, 101, 114, 115,
]);
// PsyOptions permissioned market PDA
const findPsyOpenOrdersAddress = async (marketProxy, vaultAuthority, programId) => {
    return await web3_js_1.PublicKey.findProgramAddress([
        openOrdersSeed,
        marketProxy.dexProgramId.toBuffer(),
        marketProxy.market.address.toBuffer(),
        vaultAuthority.toBuffer(),
    ], programId);
};
exports.findPsyOpenOrdersAddress = findPsyOpenOrdersAddress;
const getMarketAndAuthorityInfo = async (program, optionMarket, dexProgramId, serumQuoteAsset) => {
    const textEncoder = new util_1.TextEncoder();
    const [serumMarketKey, _serumMarketBump] = await web3_js_1.PublicKey.findProgramAddress([
        optionMarket.key.toBuffer(),
        serumQuoteAsset.toBuffer(),
        textEncoder.encode("serumMarket"),
    ], program.programId);
    const [marketAuthority, marketAuthorityBump] = await web3_js_1.PublicKey.findProgramAddress([
        textEncoder.encode("open-orders-init"),
        dexProgramId.toBuffer(),
        serumMarketKey.toBuffer(),
    ], program.programId);
    return { serumMarketKey, marketAuthority, marketAuthorityBump };
};
exports.getMarketAndAuthorityInfo = getMarketAndAuthorityInfo;
